$( document ).ready( function() {
	
	$(document).on("click",".mod-hom1__switchbutton",function(){//switchCurrency
		switchCur();
	});
	function switchCur(){
		var currencyTemp = $('[name="selectedFromCurrencyCode"]').val();
		$('[name="selectedFromCurrencyCode"]').val($('[name="selectedToCurrencyCode"]').val());
		$('[name="selectedToCurrencyCode"]').val(currencyTemp).change();
	};
  // setTimeout( function() {
    
  //   $( '.focus.curDay' ).removeClass( 'curDay' );
  
  // }, 1000 );

  //cookie banner setup
//  if($("[data-component=Com3Cookie]").length > 0){
//
//    function setCookie(cname,cvalue,exdays) {
//      var d = new Date();
//      d.setTime(d.getTime() + (exdays*24*60*60*1000));
//      var expires = "expires=" + d.toGMTString();
//      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
//    }
//    
//    function getCookie(cname) {
//        var name = cname + "=";
//        var decodedCookie = decodeURIComponent(document.cookie);
//        var ca = decodedCookie.split(';');
//        for(var i = 0; i < ca.length; i++) {
//            var c = ca[i];
//            while (c.charAt(0) == ' ') {
//                c = c.substring(1);
//            }
//            if (c.indexOf(name) == 0) {
//                return c.substring(name.length, c.length);
//            }
//        }
//        return "";
//    }
//    
//    function checkCookie() {
//        var user=getCookie("gdpr_cookie_consent") || "";
//        if (user !== "") {
//          if(user!=="0"){
//            $("[data-component=Com3Cookie]").addClass("hide");
//          } else{
//            $("[data-component=Com3Cookie]").removeClass("hide");
//          }         
//        } else {
//          $("[data-component=Com3Cookie]").removeClass("hide");
//          //create and set cookie gdpr_cookie_consent as 0
//          setCookie("gdpr_cookie_consent", "0", 365);             
//        }
//    }
//  
//    //check if cookie gdpr_cookie_consent exists
//    checkCookie();
//    
//    //close cookie modal and hide it for 1 year
//    $("[data-cookie=closeCookie]").click(function(){
//
//      $("[data-component=Com3Cookie]").addClass("hide");
//
//      //set cookie gdpr_cookie_consent as 1
//      setCookie("gdpr_cookie_consent", "1", 365);
//
//    });
//
//  }

  //home message
  if($("*[data-message=wrapMessage]").length>0){

    //maintain message hidden for the whole session, if closed
    $("*[data-message=wrapMessage] .com3__close").click(function(){

      //console.log("hide message and maintain it hidden for the session");
      $("*[data-message=wrapMessage]").addClass("hide");
      sessionStorage.setItem('hideMessage','true');

    });

    //check the visibility of the message
    var hideMessage = sessionStorage.getItem('hideMessage') || '';

    if (hideMessage !== ''){

      $("*[data-message=wrapMessage]").addClass("hide");

    } else{

      $("*[data-message=wrapMessage]").removeClass("hide");

    }

  }

} );
